module.exports = __webpack_public_path__ + "img/railway.e4f94835.png";